<template lang="pug">
  v-layout(row wrap)
    v-flex(xs12)
      Navbar(
        :noBackChevron="true"
      )
    div.home-banner
      responsive-flex
        v-img.mx-5(
          :src="onCallAirLogo"
        )

    responsive-flex
      v-list.full-width
        // Similar Home Links
        template(v-if="loading")
          v-flex.justify-center(xs12 m6)
            FanLoader#home-fan-spinner(
              :loading="loading"
            )
            div(slot="loadingMsg"
              class="full-width text-xs-center headline my-2"
            ) Loading your dashboard...
        template(v-else)
          div(
            v-if="integrationStatus === 'Boarded'"
          )
            v-list-tile.home-link-bottom-border(
              avatar
              :key="'My Payments'"
            ) 
              router-link.home-link(
                    :to="'/payments'"
                    :id="'payments-link'"
                  )
                  v-list-tile-avatar
                    v-icon.pl-4(color="primary") payments
                  v-list-tile-content
                    v-list-tile-title.black--text Payment Processing
                  v-list-tile-action.mr-2
                    v-icon chevron_right
            v-divider
          
          template( v-for="item in homePageLinks")
            v-list-tile.home-link-bottom-border(
              avatar
              :key="item.text"
            )
              router-link.home-link(
                :to="item.link"
                :id="item.id"
              )
                v-list-tile-avatar
                  v-icon(
                    color="primary"
                  ) {{ item.icon }}
                v-list-tile-content
                  v-list-tile-title.black--text {{ item.text }}
                v-list-tile-action.mr-2
                  v-icon chevron_right
            v-divider

</template>

<script>
  import FanLoader from 'Components/FanLoader.vue'
  import Navbar from 'Components/Navbar.vue'
  import ResponsiveFlex from 'Components/ResponsiveFlex.vue'
  import { delayMilliseconds } from 'Helpers/utilFunctions.js'
  import { mapActions, mapState } from 'vuex'

  export default {
    name: 'home',
    components: {
      FanLoader,
      Navbar,
      ResponsiveFlex,
    },
    data () {
      return {
        homePageLinks: {
          apply: {
            id: 'application-link',
            link: '/credit-application/plans',
            text: 'Estimate & Apply',
            icon: 'attach_money'
          },
          history: {
            id: 'history-link',
            link: '/application-history',
            text: 'Leads & History',
            icon: 'history'
          },
          plans: {
            id: 'plans-link',
            link: '/finance-options',
            text: 'Finance Options',
            icon: 'settings_input_component'
          },
        },
        loading: true,
        longLogo: require('Assets/logo_dark_bg_full@2x.png'),
        onCallAirLogo: require('@/assets/oncallair_logo.png'),
      }
    },
    computed: {
      ...mapState({
        dealerId: state => state.user.dealerId,
        userName: state => state.user.firstName,
        integrationStatus: state => state.integration.integrationStatus,
      })
    },
   
    methods: {
      ...mapActions([
        'resetSessionTimer',
        'signOut',
        'getClearentIntegrationStatus',
      ]),
    },
    created() {
      this.resetSessionTimer()
    },
    async mounted() {
      try { 
        await delayMilliseconds(2000)
        await this.getClearentIntegrationStatus()
      } catch(error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import '~Styles/_base';

  .home-banner {
    height: 45vw;
    max-height: 300px;
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    background-color: #fff
  }

  .home-link {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-decoration: none;
    font-size: 1em;

    &:visited {
      color: $primaryColor;
    }

    & .v-list__tile__title {
      font-weight: 500;
    }
  }
</style>
